import React from 'react';
import ReactDOM from 'react-dom';

const SaveEditedImageDialog = ({
  canOverride = true,
  saving = false,
  onOverride,
  onSaveNew,
  onCancel,
}) => ReactDOM.createPortal(
  <div className="fixed inset-0 z-[1400] flex items-center justify-center bg-black/50 p-4" role="dialog" aria-modal="true">
    <div className="w-full max-w-sm rounded-2xl bg-white dark:bg-gray-800 shadow-xl border border-gray-200 dark:border-gray-700 p-5">
      <h3 className="text-base font-semibold text-gray-900 dark:text-white">Save edited image</h3>
      <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
        Override the current image, or post this edit as a new image.
      </p>
      <div className="mt-4 space-y-2">
        <button
          type="button"
          disabled={saving || !canOverride}
          onClick={onOverride}
          className="w-full rounded-xl bg-primary-600 px-3 py-2.5 text-sm font-medium text-white hover:bg-primary-700 disabled:opacity-50"
        >
          {saving ? 'Saving…' : 'Override image'}
        </button>
        {!canOverride && (
          <p className="text-[11px] text-gray-500 dark:text-gray-400">
            Only the image creator can override this image.
          </p>
        )}
        <button
          type="button"
          disabled={saving}
          onClick={onSaveNew}
          className="w-full rounded-xl border border-gray-300 dark:border-gray-600 px-3 py-2.5 text-sm font-medium text-gray-800 dark:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50"
        >
          Save as new image
        </button>
        <button
          type="button"
          disabled={saving}
          onClick={onCancel}
          className="w-full px-3 py-2 text-sm text-gray-500 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>,
  document.body,
);

export default SaveEditedImageDialog;
